/**
 * 밀집 행렬용 LU 분해 (부분 피벗팅) 선형 연립방정식 솔버.
 * MNA 행렬은 보통 수십~수백 차원이라 밀집 LU로 충분히 빠르다.
 */

/** A(n x n)를 제자리에서 LU 분해한다. 성공하면 true. */
export function luDecompose(a: Float64Array, n: number, pivot: Int32Array): boolean {
  for (let i = 0; i < n; i++) pivot[i] = i;

  for (let k = 0; k < n; k++) {
    let best = 0;
    let bestRow = -1;
    for (let i = k; i < n; i++) {
      const v = Math.abs(a[i * n + k]);
      if (v > best) {
        best = v;
        bestRow = i;
      }
    }
    // 특이행렬(연결되지 않은 노드, 전압원 루프 등)
    if (bestRow < 0 || best < 1e-250) return false;

    if (bestRow !== k) {
      for (let j = 0; j < n; j++) {
        const t = a[k * n + j];
        a[k * n + j] = a[bestRow * n + j];
        a[bestRow * n + j] = t;
      }
      const t = pivot[k];
      pivot[k] = pivot[bestRow];
      pivot[bestRow] = t;
    }

    const diag = a[k * n + k];
    for (let i = k + 1; i < n; i++) {
      const f = a[i * n + k] / diag;
      a[i * n + k] = f;
      if (f !== 0) {
        for (let j = k + 1; j < n; j++) a[i * n + j] -= f * a[k * n + j];
      }
    }
  }
  return true;
}

/** luDecompose 결과를 이용해 Ax = b 를 푼다. */
export function luSolve(
  lu: Float64Array,
  n: number,
  pivot: Int32Array,
  b: Float64Array,
  x: Float64Array,
): void {
  for (let i = 0; i < n; i++) x[i] = b[pivot[i]];

  // 전진 대입 (L은 단위 하삼각)
  for (let i = 1; i < n; i++) {
    let sum = x[i];
    for (let j = 0; j < i; j++) sum -= lu[i * n + j] * x[j];
    x[i] = sum;
  }

  // 후진 대입
  for (let i = n - 1; i >= 0; i--) {
    let sum = x[i];
    for (let j = i + 1; j < n; j++) sum -= lu[i * n + j] * x[j];
    x[i] = sum / lu[i * n + i];
  }
}
